import { create } from 'zustand';
import { SchedulesState } from './schedules.store.types';
import {
  B2bCustomer,
  ScheduleByLineSchedulesQuery,
  ScheduleByLineSchedulesQueryVariables,
  ScheduleCollection,
  SecondaryUser,
} from 'types/graphql';
import { QUERY_scheduleByLineSchedules } from 'queries';
import { handleGenericErrorMessage } from 'utils/handleGenericErrorMessage';
import { devtoolsInNonProd } from 'store/zustand/index.utils';

export const schedulesStore = create<SchedulesState>()(
  devtoolsInNonProd((set, get) => ({
    data: {} as ScheduleCollection,
    loading: 0,
    error: null,
    hasInitialized: false,

    // Actions
    setError: (error) => set({ error }),
    fetchData: async (apolloClient, variables) => {
      set((state) => ({ loading: state.loading + 1, error: null }));

      try {
        const { data } = await apolloClient.query<
          ScheduleByLineSchedulesQuery,
          ScheduleByLineSchedulesQueryVariables
        >({
          query: QUERY_scheduleByLineSchedules,
          variables,
          fetchPolicy: 'network-only',
        });

        const byLineScheduleCollection =
          (data?.me as B2bCustomer | SecondaryUser)?.byLineScheduleCollection || {};

        set((state) => ({
          data: byLineScheduleCollection,
          loading: Math.max(0, state.loading - 1),
          hasInitialized: true,
        }));
      } catch (error) {
        handleGenericErrorMessage(error);
        set((state) => ({
          error,
          loading: Math.max(0, state.loading - 1),
        }));
      }
    },

    reset: () =>
      set({
        data: {} as ScheduleCollection,
        loading: 0,
        error: null,
        hasInitialized: false,
      }),
  })),
);

export const useSchedulesStore = schedulesStore;
